import { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Row, Col, Card, Spinner, Alert } from "react-bootstrap";
import { RiLineChartLine } from "react-icons/ri";
import api from "../../../../common/api";

ChartJS.register(ArcElement, Tooltip, Legend);
const Color = ["#095fbd", "#69a7e8"];

export default function LeadsWonConversionChart() {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [active, setActive] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get("/lead/leads_growth");
        setData(res.data || {});
      } catch (err) {
        setError(err.message || "Failed to load leads conversion data.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const total = data.last_six_months_total_leads ?? 0;
  const won = data.last_six_months_won_leads ?? 0;
  const notWon = Math.max(total - won, 0);
  const conversionRate = total > 0 ? ((won / total) * 100).toFixed(1) : "0.0";
  const hasData = total > 0;
  const entries = [["Won", won], ["Total Leads", notWon]];
  const chartData = {
    labels: entries.map(([k]) => k),
    datasets: [
      {
        data: entries.map(([, v]) => v),
        backgroundColor: Color,
        borderColor: "#fff",
        borderWidth: 1,
        hoverBorderWidth: 3,
        hoverOffset: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => {
            const value = ctx.parsed;
            const pct = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
            return ` ${value}`;
          }},
        backgroundColor: "#0D0F1A",
        titleColor: "#F9FAFB",
        bodyColor: "#F9FAFB",
        padding: 14,
        cornerRadius: 10,
        borderWidth: 0,
        titleFont: { size: 11, weight: "600" },
        bodyFont: { size: 13, weight: "500" },
      }},
    onHover: (_, els) => setActive(els.length ? els[0].index : null),
  };

  return (
    <Card.Body className="pb-0">
      <Card.Title className="fw-bold mb-1 planset-title">Leads Converted to Won</Card.Title>
      <Card.Subtitle className="planset-subtitle">Last 6 Months conversion overview</Card.Subtitle>
      {error ? <Alert variant="danger" className="mb-0">{error}</Alert>
       : loading ? <Row className="align-items-center justify-content-center m-0 planset-state-box"><Col xs="auto"><Spinner animation="border" size="sm" /></Col></Row>
       : !hasData ? 
        <Row className="flex-column align-items-center justify-content-center m-0 text-center planset-state-box planset-no-data">
          <Col xs="auto"><RiLineChartLine size={20} /></Col>
          <Col xs="auto"><p className="mb-0 planset-no-data_title">No Data Available</p></Col>
          <Col xs="auto"><p className="mb-0">No records found</p></Col>
        </Row>
       : <>
          <Row xs={12} md={3} sm={12} className="align-items-center" style={{height:"13.9rem"}}><Col className="lead-pie"><Pie data={chartData} options={options} /></Col></Row>
          <Row xs={12} md={3} className="text-center mt-1">
            <Col><div className="fs-5 fw-semibold">{total}</div><div className="fw-semibold">Total Leads</div></Col>
            <Col><div className="fs-5 fw-semibold">{won}</div><div className="fw-semibold">Won Leads</div></Col>
            <Col><div className="fs-5 fw-semibold">{conversionRate}%</div><div className="fw-semibold">Conversion</div></Col>
          </Row>
         </>}
    </Card.Body>
  );
}